import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, MenuItem } from '@mui/material';
import { toast } from 'react-toastify';
import CustomSelect from '../../../v2/MUI_custom_component/Select/CustomSelect';
import { useEntityState } from './hooks/useEntityState';
import { useNavigate } from 'react-router-dom';
import { TextField } from '../../../v2/MUI_custom_component';
import { STATUS } from './Enums';
import { getSelectedEntityStatus } from '../../Reducers/Entity/EntityReducer';
import { clearEntity, fetchEntity } from './actions/reduxActions';
import { toCapitalized } from '../../../v2/Utils/Capitalize';

const Entity = ({
  onSupplierChange,
  onEntityChange,
  supplierLabel = "Manufacturer*",
  entityLabel = "SAP Code*",
  showManufacturerSelect = false,
  showEntitySelect = true,
  gridSizes = { 
    supplier: { xs: 6, sm: 6, md: 3 }, 
    entity: { xs: 12, sm: 12, md: 3 } 
  },
  desktopmb = 2,
  disabled = false,
  moduleSpecificSapCodes = [],
  enableSapCodeFiltering = false,
  module_name = null,
}) => {
  const {
    suppliers,
    selectedSupplier,
    selectedEntity,
    selectedSupplierData,
    loading,
    error,
    fetchSuppliers,
    selectSupplier,
    selectEntity,
    disabledEntity = false,
  } = useEntityState();
  const navigate = useNavigate();
  const entityStatus = useSelector(getSelectedEntityStatus);
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (!suppliers.length && !loading) {
  //     fetchSuppliers();
  //   }
  // }, []);
  
  useEffect(() => {
    if (module_name && showEntitySelect) {
      dispatch(fetchEntity(selectedSupplier, module_name ));
    }
  }, [module_name, showEntitySelect]);

  const handleSupplierChange = (value) => {
    selectSupplier(value);
    dispatch(clearEntity());
    if (onSupplierChange) {
      onSupplierChange(value);
    }
  };

  const handleEntityChange = (value) => {
    selectEntity(value);
    if (onEntityChange) {
      onEntityChange(value);
    }
  };
  
  // Use entity array from redux (populated by fetchEntity)
  const entityList = useSelector(state => state.entityReducer.entity_info || []);
  const validEntities = entityList.filter(entity => entity.status !== STATUS.PENDING && (entity.status !== STATUS.INACTIVE || entity.has_history !== false));
  const filteredEntities = enableSapCodeFiltering && moduleSpecificSapCodes.length > 0
    ? validEntities.filter(entity => 
        !moduleSpecificSapCodes.some(sapCode => 
          sapCode === entity.external_system_code
        )
      )
    : validEntities;
  useEffect(() => {
    if (filteredEntities.length > 0 && !selectedEntity) {
      selectEntity(filteredEntities[0].esi_id);
    }
  }, [filteredEntities.length, selectedEntity]);

  useEffect(() => {
    if (enableSapCodeFiltering && moduleSpecificSapCodes.length > 0 && selectedEntity) {
      const selectedEntityData = entityList.find(entity => entity.esi_id === selectedEntity);
      if (selectedEntityData && moduleSpecificSapCodes.includes(selectedEntityData.external_system_code)) {
        filteredEntities.length > 0 && selectEntity(filteredEntities[0].esi_id);
      }
    }
  }, [moduleSpecificSapCodes.length, enableSapCodeFiltering, selectedEntity, entityList.length]);
  const hasEntities = filteredEntities.length > 0;
  const isEntityEnabled = selectedSupplierData?.entity_enabled !== false;
  const isEntityDisabled = disabled || filteredEntities.length <= 1 || disabledEntity;

  return (
    <Grid container spacing={2} sx={{ mb: { xs: 2, md: desktopmb} }}>
      {showManufacturerSelect && (
        <Grid item {...gridSizes.supplier}>
          <CustomSelect
            id="select-manufacturer"
            label={supplierLabel}
            value={selectedSupplier}
            disabled={disabled || loading || (suppliers.length === 1 && selectedSupplier)}
            onChange={(e) => handleSupplierChange(e.target.value)}
            fullWidth
          >
            {suppliers.map((supplier) => (
              <MenuItem key={supplier.id} value={supplier.id}>
                {supplier.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
      )}
      {showEntitySelect && isEntityEnabled && hasEntities && (
        <Grid item {...gridSizes.entity}>
          {isEntityDisabled ||(enableSapCodeFiltering && filteredEntities.length === 1) ? (
            <TextField
              id="select-sap-code"
              label={entityLabel}
              value={filteredEntities[0].external_system_code}
              disabled={isEntityDisabled}
              fullWidth
              fetchedState={true}
            />
          ) : (
            <CustomSelect
              id="select-sap-code"
              label={entityLabel}
              value={selectedEntity || (filteredEntities[0]?.esi_id || '')}
              disabled={isEntityDisabled}
              onChange={(e) => handleEntityChange(e.target.value)}
              fullWidth
            >
              {filteredEntities.map((entity) => (
                <MenuItem key={entity.esi_id} value={entity.esi_id}>
                  {toCapitalized(entity.role)} - {entity.external_system_code}
                </MenuItem>
              ))}
            </CustomSelect>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default Entity;